<template >
  <div :key="forKey">
    <div v-if="!cookiesObject.token"> 
      <p class="someText" style="text-align: center;">{{ $t('LanguageEn.myTeamsText1') }} <img src="@/assets/favorite1.png" style="width: 14px; margin-top: -4px;" alt=""> {{ $t('LanguageEn.myTeamsText2') }}</p>  
    </div>
    <div style="background: #333333; border-radius: 5px; margin-bottom: 10px; padding-bottom: 1px; padding-top: 10px;" v-else>
      <div v-if="favs.length != 0">
      <div style="padding-top: 0px; margin-left: 5px; margin-right: 5px;" v-for="fav in favs" :key="fav.id">
        <p class="someText MobileHide" style="text-align: left;" >
          <img :src="defLogo + fav.id" style="width: 21px; margin-bottom: 5px; margin-right: 2px;" alt=""> <router-link  style="color:white;" id="router-link" :to="{ name: 'teamPagePar', params: { id: fav.id, name: fav.name } }"> <span v-b-tooltip.hover :title="fav.name" v-if="ssize > 768 && ssize <= 992"> {{fav.name.slice(0,3)}}. </span> <span v-if="ssize > 992 && ssize <= 1200"> <span  v-if="fav.name.length < 13">{{fav.name}} </span> <span v-b-tooltip.hover :title="fav.name" v-else>{{fav.name.slice(0,10)}}..</span> </span> <span v-else-if="ssize <= 768"></span> <span v-if="ssize > 1200"> <span v-if="fav.name.length < 15">{{fav.name}} </span> <span v-b-tooltip.hover :title="fav.name" v-else>{{fav.name.slice(0,14)}}..</span> </span>  </router-link> <b-btn v-if="ssize > 772" v-on:click="removeFavorite({value: fav.id , type: team})" style="float: right; background: none; border: none; margin-top: -7px;"> <img src="@/assets/delete.png" style="width: 10px; margin-bottom: 10px;" alt=""> </b-btn>
        </p>
        <p class="someText MobileShow" style="text-align: left; height: 40px;">
          <img :src="defLogo + fav.id" style="width: 21px; margin-bottom: 5px; margin-right: 2px;" alt=""> <router-link  style="color:white;" id="router-link" :to="{ name: 'teamPagePar', params: { id: fav.id, name: fav.name } }"> <span v-if="fav.name.length > 24">{{fav.name.slice(0,24)}}..</span> <span v-else>{{fav.name}}</span> </router-link> <b-btn v-on:click="removeFavorite({value: fav.id , type: team})" style="float: right; background: none; border: none; margin-top: -7px;"> <img src="@/assets/delete.png" style="width: 10px; margin-bottom: 10px;" alt=""> </b-btn>
        </p>
      </div>
    </div>
    <div v-else>
      <p class="someText" style="text-align: center;">{{ $t('LanguageEn.myTeamsText1') }} <img src="@/assets/favorite1.png" style="width: 14px; margin-top: -4px;" alt=""> {{ $t('LanguageEn.myTeamsText2') }}</p>  
    </div>
    </div>
</div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex';

export default {
  name: 'HeaderBody',
    data(){
      return{
        cookiesObject: '',
        defLogo: 'https://sportapi.zuniac.com/team/logo/',   
        forKey: '',
        team: 'team',
        ssize: '',
        }
  },

   mounted(){
    var cookiesObject = document.cookie.split(';').map(cookie => cookie.split('=')).reduce((accumulator, [key, value]) => ({...accumulator, [key.trim()]: decodeURIComponent(value)}),{});
    this.cookiesObject = cookiesObject;


    if (this.cookiesObject.token) {
    this.getArray();
    }
    
    window.addEventListener('resize', this.nowSize);
    this.nowSize();
    },

    destroyed(){
      window.removeEventListener('resize', this.nowSize);
    
    },
    
    methods:{
      ...mapActions(["getArray", "removeFavorite"]),
      nowSize(){
        this.ssize = window.innerWidth;
      }
    },  

  props: {
  },
  computed: {
      ...mapGetters(["favs"]),
  },

  watch: {
  
  },

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.someText{
    background: #4d4d4d;
    border-radius: 5px;
    color: white;
    text-align: center;
    margin-bottom: 10px;  
    padding: 10px;
    font-size: small;
}
@media only screen and (max-width: 770px) {
  .MobileHide {
    display: none;
  }
}

@media only screen and (min-width: 770px) {
  .MobileShow {
    display: none;
  }
}
</style>
